var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('content-entity-layout');
import { breakpoints, theme } from '@shapeable/theme';
import { get } from 'lodash';
import { ContentEntityIntro } from './content-entity-intro';
import { PageMeta } from './page-meta';
import { PageAuthor } from './page-author';
import { ContentEntityContent } from './content-entity-content';
import { ImageAssetWithDescription } from './image-asset-with-description';
import { MainAside } from '../elements/main-aside';
import { useEntity } from '../hooks/use-entity';
import { CSS_DOTS, CSS_DOTS_END } from '../constants';
import { first } from 'lodash';
import { Helmet } from 'react-helmet';
import { ContentEntityThumbnailGrid } from './content-entity-thumbnail-grid';
import { ShareButtons } from '../elements/share-buttons';
import { useLang } from '../hooks/use-lang';
import { CellLabel } from '../elements/cell-label';
import { ContentEntityOutro } from './content-entity-outro';
import { ContentEntityRichTitle } from './content-entity-rich-title';
import { ContentEntityRichSubtitle } from './content-entity-rich-subtitle';
import { useComponentPropsFor } from '../context/component-props-context';
import { DownloadButton } from '../elements/download-button';
export var ContentEntityLayoutDefaultProps = {
  shareButtonsLabel: 'Share This Content:',
  showImage: true,
  showTitles: false,
  showMeta: true,
  isAsideSticky: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MainAsideStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n\n    main {\n      order: 2;\n    }\n\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n\n    main {\n      order: 2;\n    }\n\n  "])), theme.UNIT(8), theme.UNIT(8)),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    main {\n      order: 0;\n    }\n  "], ["\n    main {\n      order: 0;\n    }\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme.UNIT(8))
});
var IntroStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(6))
});
var MainStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var AsideStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n  "], ["\n  ", "\n  "])), function (_a) {
    var hasAsideLayout = _a.hasAsideLayout,
      isSticky = _a.isSticky;
    return hasAsideLayout && isSticky && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    height: 100%;\n    \n  "], ["\n    height: 100%;\n    \n  "])));
  })
});
var GridStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n    ", ";\n  "], ["\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n    ", ";\n  "])), theme.UNIT(4), theme.UNIT(4), CSS_DOTS_END)
});
var MetaStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: 0.85em;\n    margin-bottom: ", ";\n  "], ["\n    font-size: 0.85em;\n    margin-bottom: ", ";\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(1))
});
var PersonStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var FooterStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    ", ";\n    padding-top: ", ";\n  "], ["\n    ", ";\n    padding-top: ", ";\n  "])), CSS_DOTS, theme.UNIT(4))
});
var OutroStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    font-size: 0.95em;\n  "], ["\n    font-size: 0.95em;\n  "])))
});
var AuthorStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(4))
});
var ShareStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", ";\n    padding-top: ", ";\n  "], ["\n    ", ";\n    padding-top: ", ";\n  "])), CSS_DOTS, theme.UNIT(4))
});
var ShareButtonsStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(3))
});
var ShareLabelStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    font-size: 1em;\n    font-weight: 300;\n    color: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: 1em;\n    font-weight: 300;\n    color: ", ";\n    margin-bottom: ", ";\n  "])), theme.COLOR('text-mid'), theme.UNIT(3))
});
var TitleStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    line-height: 1.15em;\n  "], ["\n    margin-bottom: ", ";\n    line-height: 1.15em;\n  "])), theme.UNIT(4))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    line-height: 1.15em;\n  "], ["\n    margin-bottom: ", ";\n    line-height: 1.15em;\n  "])), theme.UNIT(4))
});
var AsideLayoutContainerStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isSticky = _a.isSticky;
    return isSticky && css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n      position: sticky;\n      top: 92px;\n    \n    "], ["\n      position: sticky;\n      top: 92px;\n    \n    "])));
  })
});
var ButtonStyles = breakpoints({
  base: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    margin: ", " 0;\n  "], ["\n    margin: ", " 0;\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: styled(ContentEntityThumbnailGrid)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Title: styled(ContentEntityRichTitle)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: styled(ContentEntityRichSubtitle)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  MainAside: styled(MainAside)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled.div.attrs(cls.attr('main'))(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Intro: styled(ContentEntityIntro)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Content: styled(ContentEntityContent)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Footer: styled.div.attrs(cls.attr('footer'))(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  Author: styled(PageAuthor)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), AuthorStyles),
  Outro: styled(ContentEntityOutro)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles),
  Aside: styled.div.attrs(cls.attr('aside'))(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Meta: styled(PageMeta)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), MetaStyles),
  AsideLayoutContainer: styled.div.attrs(cls.attr('aside-layout-container'))(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), AsideLayoutContainerStyles),
  DownloadButton: styled(DownloadButton)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Share: styled.div.attrs(cls.attr('share'))(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), ShareStyles),
  ShareLabel: styled(CellLabel)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), ShareLabelStyles),
  ShareButtons: styled(ShareButtons)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), ShareButtonsStyles),
  Image: styled(ImageAssetWithDescription)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var ContentEntityLayout = function (props) {
  var _a, _b;
  var _c = useComponentPropsFor('ContentEntityLayout', ContentEntityLayoutDefaultProps, props),
    className = _c.className,
    children = _c.children,
    showTitles = _c.showTitles,
    showImage = _c.showImage,
    showMeta = _c.showMeta,
    showShareButtons = _c.showShareButtons,
    asideLayout = _c.asideLayout,
    isAsideSticky = _c.isAsideSticky,
    downloadButtonProps = _c.downloadButtonProps;
  var entity = useEntity(props.entity);
  var t = useLang();
  var title = entity.title,
    titleRich = entity.titleRich,
    subtitle = entity.subtitle,
    subtitleRich = entity.subtitleRich,
    _d = entity.imageAssets,
    imageAssets = _d === void 0 ? [] : _d,
    _e = entity.authors,
    authors = _e === void 0 ? [] : _e,
    _f = entity.people,
    people = _f === void 0 ? [] : _f,
    created = entity.created,
    _g = entity.marqueePages,
    marqueePages = _g === void 0 ? [] : _g,
    _h = entity.featurePages,
    featurePages = _h === void 0 ? [] : _h,
    _j = entity.featurePosts,
    featurePosts = _j === void 0 ? [] : _j,
    content = entity.content,
    intro = entity.intro,
    outro = entity.outro,
    _k = entity.files,
    files = _k === void 0 ? [] : _k;
  var person = first(__spreadArray(__spreadArray([], __read(authors), false), __read(people), false));
  var image = first(imageAssets);
  var hasAuthor = !!person;
  var hasOutro = outro && outro.text;
  var hasContent = content && !!content.text;
  var hasIntro = intro && intro.text;
  var hasFooter = hasAuthor || hasOutro;
  var hasImage = showImage && image;
  //Below file is a temporary fix for the download button. Should we allow for multiple files to be listed?
  var hasFile = !!files.length;
  var url = ((_b = (_a = files[0]) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.url) || "/pdf";
  var downloadUrl = url.replace(/upload\//, 'upload/fl_attachment/');
  var hasAside = !!asideLayout || hasFile;
  var hasTitle = title || get(titleRich, 'text');
  var hasSubtitle = subtitle || get(subtitleRich, 'text');
  var imageUrl = image && image.image && image.image.url;
  var shareButtonsLabel = t(props.shareButtonsLabel);
  if (!hasImage && (!showTitles || !hasTitle && !hasSubtitle) && !hasOutro && !hasContent && !hasIntro) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, !!marqueePages.length && React.createElement(My.Grid, {
    items: marqueePages
  }), !!featurePages.length && React.createElement(My.Grid, {
    items: featurePages
  }), !!featurePosts.length && React.createElement(My.Grid, {
    items: featurePosts
  }), showImage && image && React.createElement(My.Image, {
    entity: image
  }), showTitles && React.createElement(My.Title, {
    entity: entity
  }), showTitles && React.createElement(My.Subtitle, {
    entity: entity
  }), imageUrl && React.createElement(Helmet, null, React.createElement("meta", {
    property: "og:image",
    content: imageUrl
  }), React.createElement("meta", {
    name: "image",
    content: imageUrl
  }), React.createElement("meta", {
    name: "twitter:image",
    content: imageUrl
  })), React.createElement(My.MainAside, {
    space: 14,
    main: React.createElement(My.Main, null, React.createElement(My.Intro, {
      entity: entity
    }), React.createElement(My.Content, {
      entity: entity
    }), hasFooter && React.createElement(My.Footer, null, hasAuthor && React.createElement(My.Author, {
      entity: entity
    }), hasOutro && React.createElement(My.Outro, {
      entity: entity
    }))),
    aside: showMeta && React.createElement(My.Aside, {
      hasAsideLayout: hasAside,
      isSticky: isAsideSticky
    }, React.createElement(My.Meta, {
      entity: entity
    }), showShareButtons && React.createElement(My.Share, null, React.createElement(My.ShareLabel, null, shareButtonsLabel), React.createElement(My.ShareButtons, null)), hasAside && React.createElement(My.AsideLayoutContainer, {
      isSticky: isAsideSticky
    }, asideLayout, hasFile && React.createElement(My.DownloadButton, __assign({}, downloadButtonProps, {
      href: downloadUrl || "/pdf"
    }), "Download Full Report")))
  }));
};
// ContentEntityLayout.defaultProps = ContentEntityLayoutDefaultProps;
ContentEntityLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43;